import { Link } from 'ui-kit/actions/link/Link'
import { DOCS_LINK } from 'routes/constants'
import { UniversalIntegrationsContent } from '../Content'
import { contentData } from '../Content/contentData'
import DataModels1x from './data-models@1x.png'
import DataModels2x from './data-models@2x.png'
import classes from './UniversalIntegrationsDataModels.module.scss'

export const UniversalIntegrationsDataModels = () => {
  return (
    <section className={classes.section}>
      <div className={classes.stroke} />
      <div className={classes.wrapper}>
        <UniversalIntegrationsContent item={contentData[0]}>
          You can use{' '}
          <Link
            href={`${DOCS_LINK}/membrane/references/udm`}
            type={'lineGradient'}
            target={'_blank'}
          >
            universal data models
          </Link>{' '}
          and other cross-application building blocks to build integrations on
          the universal level.
        </UniversalIntegrationsContent>
        <div className={classes.visual}>
          <div className={classes.background} />
          <img
            srcSet={`${DataModels1x.src} 1x, ${DataModels2x.src} 2x`}
            src={DataModels1x.src}
            alt='Describe inputs, outputs, and common logic that you want to work across multiple apps.'
            width={508}
            height={460}
            className={classes.image}
            loading='lazy'
          />
        </div>
      </div>
    </section>
  )
}
